import { Button, Input, Label, useValidationResultDialog } from '@nest/uikit-react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import { useNavigate } from 'react-router';
import { useTerminalClient } from '../client-rpc-router';
import { TerminalScreen } from '../components/TerminalScreen';
import { useNumberParam } from '../helpers';

export default function ConsignmentNoteFormPage() {
	const client = useTerminalClient();
	const navigate = useNavigate();
	const queryClient = useQueryClient();
	const carrierId = useNumberParam('carrierId');
	const [containerNumber, setContainerNumber] = useState<string>('');

	const createMutation = useMutation({
		mutationFn: async () => {
			const result = await client.consignmentNotes.createConsignmentNoteMutation.execute({
				carrierId: carrierId!,
				containerNumber
			});
			return result;
		},
		onSuccess: result => {
			queryClient.invalidateQueries({ queryKey: ['consignment-notes-list'] });
			navigate(`/consignment-notes/carriers/${carrierId}/list/${result.id}`);
		}
	});

	useValidationResultDialog([createMutation.error]);

	return (
		<TerminalScreen showBackButton topBar={<div>Nový nákladní list</div>}>
			<div className="p-4 flex flex-col gap-4">
				<div>
					<Label className="mb-1 block">Kontejner</Label>
					<Input value={containerNumber} onChange={e => setContainerNumber(e.target.value)} />
				</div>

				<Button className="w-full" onClick={() => createMutation.mutate()} disabled={createMutation.isPending || !carrierId || !containerNumber}>
					Vytvořit
				</Button>
			</div>
		</TerminalScreen>
	);
}
